import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Upsell from "@/pages/Upsell";
import ThankYou from "@/pages/ThankYou";
import Local from "@/pages/Local";
import LocalDetail from "@/pages/LocalDetail";
import Pass from "@/pages/Pass";
import Account from "@/pages/Account";
import Merchant from "@/pages/Merchant";
import Admin from "@/pages/Admin";
import BrandsLanding from "@/pages/BrandsLanding";
import LocalBusinesses from "@/pages/LocalBusinesses";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Forgot from "@/pages/Forgot";
import Reset from "@/pages/Reset";

function Shell() {
  return (
    <div className="min-h-screen flex flex-col pb-16 md:pb-0">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <MobileNav />
    </div>
  );
}

function Bare() { return <Outlet />; }

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) return <div className="min-h-screen grid place-items-center text-stone-400">Loading…</div>;
  if (!user) { window.location.href = "/login"; return null; }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Shell />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/friib/:slug" element={<ProductDetail />} />
            <Route path="/local" element={<Local />} />
            <Route path="/local/:slug" element={<LocalDetail />} />
            <Route path="/brands" element={<BrandsLanding />} />
            <Route path="/local-businesses" element={<LocalBusinesses />} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/merchant" element={<Merchant />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/pass/:id" element={<Pass />} />
          </Route>
          <Route element={<Bare />}>
            <Route path="/checkout/:slug" element={<Checkout />} />
            <Route path="/upsell/:orderId" element={<Upsell />} />
            <Route path="/thank-you/:orderId" element={<ThankYou />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<Forgot />} />
            <Route path="/reset-password" element={<Reset />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
